import { ClerkLoaded, ClerkLoading, RedirectToSignIn, Show } from '@clerk/react-router';
import { LoadingBlockFullScreen } from '@plato/ui-legacy/components/loading/loading-block-full-screen';
import type { ReactNode } from 'react';

type AuthGuardProps = {
    children: ReactNode;
};

export function AuthGuard({ children }: AuthGuardProps) {
    return (
        <>
            <ClerkLoading>
                <LoadingBlockFullScreen />
            </ClerkLoading>
            <ClerkLoaded>
                <Show when="signed-in">{children}</Show>
                <Show when="signed-out">
                    <RedirectToSignIn />
                </Show>
            </ClerkLoaded>
        </>
    );
}
